import {getCurrencySymbol} from '@/helper';

const currencySymbol = {
  methods: {
    getCurrencySymbol (currency) {
      return getCurrencySymbol (currency);
    },
  },
};

const getPricingListFromApi = {
  methods: {
    async getPricingListFromApi (payload = {}) {
      try {
        var response = await this.$store.dispatch (
          'monetization/listPricing',
          payload
        );
        return response;
      } catch (error) {
        this.$store.dispatch ('app/showMessage', {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },
  },
};

export {currencySymbol, getPricingListFromApi};
